export default function PHP_real_escape_string() {
  return (
    <div>
      <h1>PHP_real_escape_string</h1>
    </div>
  );
}
